import { doc, FieldValue, increment } from 'firebase/firestore';
import { Goal, UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { lifeAreaOtherID } from 'shared/types/orderable-section';
import { isNumber } from 'shared/utils/is-number';

import { dateToFirestoreTimestamp } from './converters/date-to-firestore-timestamp';
import {
  CollectionOptions,
  getCollection,
  updateDocWithTimestamp,
} from './helpers';

export const updateGoal = async (goal: UpdateGoal, forceValues?: boolean) => {
  if (!goal.id) {
    return;
  }

  Object.entries(goal).forEach(([key, value]) => {
    if (value === undefined) {
      delete goal[key as keyof Goal];
    }
  });
  const goalCollection = getCollection(CollectionOptions.Goals);
  const docRef = doc(goalCollection, goal.id);
  const { taskCount, completedTaskCount, parentIds, ...rest } = goal;
  const data: typeof rest & {
    taskCount?: FieldValue | number;
    completedTaskCount?: FieldValue | number;
    parentIds?: ID[] | null;
  } = dateToFirestoreTimestamp({ ...rest });

  if (forceValues && isNumber(taskCount)) {
    data.taskCount = taskCount!;
  }
  if (forceValues && isNumber(completedTaskCount)) {
    data.completedTaskCount = completedTaskCount!;
  }

  if (!forceValues && taskCount) {
    data.taskCount = increment(taskCount);
  }
  if (!forceValues && completedTaskCount) {
    data.completedTaskCount = increment(completedTaskCount);
  }
  if (parentIds?.length) {
    data.parentIds = Array.from(new Set(parentIds));
    data.lifeAreaId = null;
  }
  if (!parentIds?.length && parentIds !== undefined) {
    data.parentIds = null;
  }
  if (data.lifeAreaId === lifeAreaOtherID) {
    data.lifeAreaId = null;
  }

  updateDocWithTimestamp(docRef, data);
};
